CustomTC.define('modules/recast/recast',['modules/util', 'modules/core', 'modules/config', 'modules/constants', 'modules/options', 'modules/load-data', 'modules/language', 'text!modules/recast/htmls/recast.html', 'text!modules/recast/htmls/remove-recast.html', 'css!modules/recast/css/recast'], function(util, core, config, constants, options, loadData, language, recast, unrecast) {
    return {
        flagRecast: 0,
        reCast: 1,
        removeReCast: 0,
        videoReCastMsg: 'Do you want to redirect to TouchCast.com so that you can login there and be able to reCast this TouchCast?',
        //init
        init: function(playerUI, isAjaxAllowed) {
            core.init('body').find('.' + constants.CSS_TOUCHCAST_PLAYER_CONTAINER + '').append(recast).append(unrecast);
            if (typeof(language.videoReCastPopupMsg) !== 'undefined')
                this.setVideoReCastMsg(language.videoReCastPopupMsg);
            this.setPlayerLanguageForReCastModule(playerUI);
            this.initReCast(playerUI, isAjaxAllowed);
        },
        // get reCast value
        getRecastVal: function() {
            return this.reCast;
        },
        // get remove reCast value
        getRemoveRecastVal: function() {
            return this.removeReCast;
        },
        // get flag recast
        getFlagRecast: function() {
            return this.flagRecast;
        },
        // set flag recast
        setFlagRecast: function(flag) {
            this.flagRecast = flag;
        },
        // get video recast conirmation popup msg
        getVideoReCastMsg: function() {
            return this.videoReCastMsg;
        },
        // set video recast conirmation popup msg
        setVideoReCastMsg: function(msg) {
            this.videoReCastMsg = msg;
        },
        //reCast icon click functionalities 
        initReCast: function(playerUI, isAjaxAllowed) {
            this.playerUI = playerUI;
            var self = this;
            var reCastBtn = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECAST + '');
            var reCastWrapper = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_RECAST_CONTAINER + '');
            var reCastPopupButton = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_RECAST_CONTAINER + ' #' + constants.CSS_TOUCHCAST_CONTROL_RECAST_POPUP_BUTTON_RECAST + '');
            var removeRecastPopupButton = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_REMOVE_RECAST_CONTAINER + '.' + constants.CSS_TOUCHCAST_CONTROL_RECAST_CONTAINER + ' #' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_REMOVE_RECAST + '');
            var removeRecastContainer = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_REMOVE_RECAST_CONTAINER + '.' + constants.CSS_TOUCHCAST_CONTROL_RECAST_CONTAINER + '');
            var embedConfirmationWrapper = core.init('#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP + '');
            var embedConfirmationDesc = core.init('#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP + ' #' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_DESCRIPTION + '');
            var embedConfirmationYesBtn = core.init('#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP + ' #' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_YES_BUTTON + '');
            var embedConfirmationCloseBtns = core.init('#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP + ' #' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_NO_BUTTON + ', #' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP + ' span.' + constants.CSS_TOUCHCAST_CLOSE_BUTTON + '');
            var venoBoxIframe = core.init('frame.' + constants.CSS_TOUCHCAST_VENOBOX_FRAME + '');
            var tcLoginLink = core.init('span.' + constants.CSS_TOUCHCAST_LOGIN_LINK + '');

            //while page loading, need to show the recast icon selected if recasted
            if (options.getApiUrl() === '' || !options.getApiUrl()) {
                if (!options.user || options.user.isRecasted() === '' || !options.user.isRecasted()) {
                    self.setFlagRecast(0);
                    core.removeClass(reCastBtn, constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECASTED);
                    playerUI._updateTooltipster(reCastBtn, language.getRecastTooltip());
                } else {
                    self.setFlagRecast(1);
                    core.addClass(reCastBtn, constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECASTED);
                    playerUI._updateTooltipster(reCastBtn, language.getRecastRemoveTooltip());
                }
            } else {
                if (self.getFlagRecast()) {
                    //self.setFlagRecast(1);
                    core.addClass(reCastBtn, constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECASTED);
                    playerUI._updateTooltipster(reCastBtn, language.getRecastRemoveTooltip());
                } else {
                    //self.setFlagRecast(0);
                    core.removeClass(reCastBtn, constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECASTED);
                    playerUI._updateTooltipster(reCastBtn, language.getRecastTooltip());

                }
            }

            if (util.getIEVersion() === 8) {
                setTimeout(function() {
                    core.removeClass(reCastBtn, 'icon-video-recast');
                    core.addClass(reCastBtn, 'icon-video-recast');
                }, 500);
            }
            core.off(reCastBtn, 'touchstart click');
            core.on(reCastBtn, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if (self.getFlagRecast()) {
                    if (core.hasClass(removeRecastContainer, constants.CSS_TOUCHCAST_CONTROL_RECAST_POPUP_SHOW))
                        self.hideRecastPopup();
                    else
                        self.showRecastPopup();
                } else {
                    if (core.hasClass(reCastBtn, constants.CSS_TOUCHCAST_SELECTED))
                        self.hideRecastPopup();
                    else {
                        self.showRecastPopup();
                    }
                }
                return false;
            });

            core.off(reCastPopupButton, 'touchstart click');
            core.on(reCastPopupButton, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                var msg = self.getVideoReCastMsg();
                var videoUrl = options.videoInfo[0].url;
                if (options.getApiUrl() === '' || !options.getApiUrl()) {
                    var loginUrl = videoUrl;
                } else {
                    // login url
                    var redirectUrl = videoUrl.replace(config.domain, '');
                    var redirectUrl = redirectUrl.replace('http://', '');
                    var redirectUrl = redirectUrl.replace('https://', '');
                    var redirectUrl = redirectUrl.replace('http:', '');
                    var loginUrl = config.domain + '/login?redirect=' + redirectUrl
                }
                if (playerUI.preChecksForAjaxCall(msg, loginUrl)) {
                    if (!isAjaxAllowed)
                        return false;
                    core.tooltipster(reCastBtn, 'enable');
                    self.addOrRemoveClassForRecastPopup(reCastBtn, reCastWrapper, 'removeClass');
                    core.addClass(reCastBtn, constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECASTED);
                    self.setFlagRecast(1);
                    playerUI._updateTooltipster(reCastBtn, language.getRecastRemoveTooltip());
                    var video = options.videoInfo[0];
                    loadData.reCastVideo(options.user.getPostName(), self.getRecastVal(), video.id, function(data) {});
                }
                return false;
            });

            core.off(removeRecastPopupButton, 'touchstart click');
            core.on(removeRecastPopupButton, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                var msg = self.getVideoReCastMsg();
                var videoUrl = options.videoInfo[0].url;
                // login url
                if (options.getApiUrl() === '' || !options.getApiUrl()) {
                    var loginUrl = videoUrl;
                } else {
                    // login url
                    var redirectUrl = videoUrl.replace(config.domain, '');
                    var redirectUrl = redirectUrl.replace('http://', '');
                    var redirectUrl = redirectUrl.replace('https://', '');
                    var redirectUrl = redirectUrl.replace('http:', '');
                    var loginUrl = config.domain + '/login?redirect=' + redirectUrl
                }
                if (playerUI.preChecksForAjaxCall(msg, loginUrl)) {
                    if (!isAjaxAllowed)
                        return false;
                    core.removeClass(reCastBtn, constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECASTED);
                    core.hide(removeRecastContainer);
                    if (core.hasClass(removeRecastContainer, constants.CSS_TOUCHCAST_CONTROL_RECAST_POPUP_SHOW)) {
                        core.tooltipster(reCastBtn, 'enable');
                        self.addOrRemoveClassForRecastPopup(reCastBtn, removeRecastContainer, 'removeClass');
                    } else {
                        core.tooltipster(reCastBtn, 'disable');
                        self.addOrRemoveClassForRecastPopup(reCastBtn, removeRecastContainer, 'addClass');
                    }
                    self.setFlagRecast(0);
                    playerUI._updateTooltipster(reCastBtn, language.getRecastTooltip());
                    var video = options.videoInfo[0];
                    loadData.reCastVideo(options.user.getPostName(), self.getRemoveRecastVal(), video.id, function(data) {});
                }
                return false;
            });
        },
        setRecast: function() {
            var self = this;
            var playerUI = self.playerUI;
            var reCastBtn = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECAST + '');
            if (self.getFlagRecast()) {
                //self.setFlagRecast(1);
                core.addClass(reCastBtn, constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECASTED);
                playerUI._updateTooltipster(reCastBtn, language.getRecastRemoveTooltip());
            } else {
                //self.setFlagRecast(0);
                core.removeClass(reCastBtn, constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECASTED);
                playerUI._updateTooltipster(reCastBtn, language.getRecastTooltip());

            }
        },
        showHideRecastPopup: function(reCastBtn) {
            var reCastWrapper = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_RECAST_CONTAINER + '');
            var removeRecastContainer = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_REMOVE_RECAST_CONTAINER + '.' + constants.CSS_TOUCHCAST_CONTROL_RECAST_CONTAINER + '');
            var showPopup;
            if (this.getFlagRecast()) {
                showPopup = removeRecastContainer;
                core.hide(reCastWrapper);
                core.show(removeRecastContainer);
            } else {
                showPopup = reCastWrapper;
                core.show(reCastWrapper);
                core.hide(removeRecastContainer);
            }
            return showPopup;
        },
        showRecastPopup: function() {
            this.playerUI.clearControlSelections();
            var reCastBtn = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECAST + '');
            var showPopup = this.showHideRecastPopup(reCastBtn);
            core.tooltipster(reCastBtn, 'disable');
            this.addOrRemoveClassForRecastPopup(reCastBtn, showPopup, 'addClass');
        },
        hideRecastPopup: function() {
            var reCastBtn = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECAST + '');
            var showPopup = this.showHideRecastPopup(reCastBtn);
            core.tooltipster(reCastBtn, 'enable');
            this.addOrRemoveClassForRecastPopup(reCastBtn, showPopup, 'removeClass');
        },
        addOrRemoveClassForRecastPopup: function(reCastBtn, reCastWrapper, type) {
            if (type === 'addClass') {
                core.addClass(reCastBtn, constants.CSS_TOUCHCAST_SELECTED);
                core.addClass(reCastWrapper, constants.CSS_TOUCHCAST_CONTROL_RECAST_POPUP_SHOW);
                core.addClass(reCastBtn, constants.CSS_TOUCHCAST_CONTROL_RECAST_POPUP_BOTTOM_ARROW);
            } else if (type === 'removeClass') {
                core.removeClass(reCastBtn, constants.CSS_TOUCHCAST_SELECTED);
                core.removeClass(reCastWrapper, constants.CSS_TOUCHCAST_CONTROL_RECAST_POPUP_SHOW);
                core.removeClass(reCastBtn, constants.CSS_TOUCHCAST_CONTROL_RECAST_POPUP_BOTTOM_ARROW);
            }
        },
        setPlayerLanguageForReCastModule: function(playerUI) {
            var tcLangReCast = core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_RECAST_TOOLTIP + '');
            var tcVideoReCasted = core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_RECAST_TOOLTIP + '.' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_RECASTED_BUTTON + '');
            var reCastThisTC = core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_RECAST_POPUP_RECAST_BUTTON + '');
            var tcLangReCastDesc = core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_RECAST_POPUP_RECAST_DESCRIPTION + '');
            var removeReCast = core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_REMOVE_RECAST_POPUP_CONTENT + '');

            //playerUI._updateTooltipster(tcLangReCast,language.getRecastTooltip());
            //playerUI._updateTooltipster(tcVideoReCasted,language.getRecastRemoveTooltip());
            core.html(reCastThisTC, language.getRecastPopupBoxTitle());
            core.html(tcLangReCastDesc, language.getRecastPopupBoxDesc());
            core.html(removeReCast, language.getRecastPopupBoxTitleRemove());
        }
    }
});
